// extracted by mini-css-extract-plugin
export default {"nameProfile":"auxjEVxZ","nameText":"VinTzaHP","wrapperAvatar":"pdgZ9Ied","desktop":"desktop","outlined":"F7I8SoIr"};